import { createSlice } from '@reduxjs/toolkit';
import { type FeatureFlagsState } from './types';
import { fetchFeatureFlags } from './thunks';

const initialState: FeatureFlagsState = {
  flags: [],
  loading: false,
  error: false,
  hydrated: false, // true when feature flag request completes with success or failure
};

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatureFlags.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchFeatureFlags.fulfilled, (state, action) => {
        state.loading = false;
        state.flags = action.payload;
        state.hydrated = true;
      })
      .addCase(fetchFeatureFlags.rejected, (state) => {
        state.loading = false;
        state.error = true;
        state.hydrated = true;
      });
  },
});

export default featureFlagsSlice.reducer;
